export default __webpack_public_path__ + "82bd60286a32b6a2534cd5369f04e7f7.png";